import { toolkitUrls } from '@/links'

async function fetchJson(url, options = {}) {
  const response = await fetch(url, { credentials: 'include', ...options })
  if (!response.ok) {
    let message = `${response.status} status response from HTTP request`
    try {
      const body = await response.text()
      if (body) message = body
    } catch { /* use default */ }
    throw new Error(message)
  }
  return response.json()
}

export async function getAnchorPageForEditing(gradeLevelUUID) {
  const url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}?with_access_points=1&prefer_draft=1`
  return fetchJson(url)
}

export async function checkAnchorPageForDraft(gradeLevelUUID) {
  const url = `${toolkitUrls.api}/anchor-access-points/draft/${gradeLevelUUID}`
  return fetchJson(url)
}

export async function publishDraftForAnchorPage(gradeLevelUUID) {
  const url = `${toolkitUrls.api}/anchor-access-points/overwrite-draft/${gradeLevelUUID}`
  return fetchJson(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  })
}

export async function deleteDraftForAnchorPage(gradeLevelUUID) {
  const url = `${toolkitUrls.api}/anchor-access-points/draft/${gradeLevelUUID}`
  return fetchJson(url, { method: 'DELETE' })
}

export async function create(title) {
  const url = `${toolkitUrls.api}/anchor-access-points`
  const response = await fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title }),
  })
  if (!response.ok) {
    let message = `${response.status} status response from HTTP request`
    try {
      const body = await response.text()
      if (body) message = body
    } catch { /* use default */ }
    throw new Error(message)
  }
  const text = await response.text()
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export async function generateAccessPoints(gradeLevelUUID) {
  const url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}`
  return fetchJson(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  })
}

export async function update({ gradeLevelUUID, uuidsToUpdate, updates }) {
  const url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}`
  return fetchJson(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uuids: uuidsToUpdate, updates }),
  })
}
